import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class ChildDocumentListService {
  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('ChildDocumentListService');
  }

  setupChildDocumentListId() {
    return this.ajsService.setupChildDocumentListId();
  }

  save() {
    return this.ajsService.save();
  }

  saveChildDocumentList() {
    return this.ajsService.saveChildDocumentList();
  }

  /**
   * get the child document info
   */
  getChildDocumentInfo(childDocumentListId) {
    return this.ajsService.getChildDocumentInfo(childDocumentListId);
  }

  resetChildDocumentListId() {
    this.ajsService.resetChildDocumentListId();
  }

  removeChildDocumentInfo(childDocumentListId) {
    this.ajsService.removeChildDocumentInfo(childDocumentListId);
  }

  clearDocuments(childDocumentListId) {
    this.ajsService.clearDocuments(childDocumentListId);
  }
}
